/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 13:36:37
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 17:28:43
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/LegalSetting/index.tsx
 */
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import { Empty } from 'antd';
import _ from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Checkbox, DropDown, Input, TextArea } from 'src/components/Antd';
import { AddableTag, ClosableTag } from 'src/components/InputBreakTag/Tag';
import { EnumPosition } from 'src/components/QuestionIconTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionHOC from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC';
import {
  EnumCollapseId,
  getCollapse,
  getLegalSetting,
  onCollapseChange,
  onLegalSettingChange,
} from 'src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/slice';
import { generateErrorKey } from 'src/tools/helper';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import { legalPermissions } from '../../Components/hooks/permission';
import css from './css.module.less';
const arrId = 'SalesChannelLegalPageLegalSettingAttribute';
const LegalSetting = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _data: any = useSelector(getLegalSetting());
  const _d = useDispatch();
  const { uuid }: any = useParams();
  const { canEdit } = legalPermissions(uuid);
  const {
    versionRemarks,
    useDefaultLegalSetting,
    entityName,
    entityRegistrationNumber,
    consentAttributes,
  } = _data || {};
  const versionRemarksErr = _data[generateErrorKey('versionRemarks')];
  const entityNameErr = _data[generateErrorKey('entityName')];
  const entityRegistrationNumberErr =
    _data[generateErrorKey('entityRegistrationNumber')];
  const handleOnRemarksChange = (versionRemarks) => {
    _d(onLegalSettingChange({ versionRemarks }));
  };
  const handleOnDefaultChange = (useDefaultLegalSetting) => {
    _d(onLegalSettingChange({ useDefaultLegalSetting }));
  };
  const handleOnEntityNameChange = (entityName) => {
    _d(onLegalSettingChange({ entityName }));
  };
  const handleOnEntityNumberChange = (entityRegistrationNumber) => {
    _d(onLegalSettingChange({ entityRegistrationNumber }));
  };
  const handleOnConsentAttributesChange = (consentAttributes) => {
    _d(onLegalSettingChange({ consentAttributes }));
  };
  return (
    <React.Fragment>
      <SectionContent hasBottomBorder>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  rightPart={
                    <CountWords
                      count={(versionRemarks || '').length}
                      allCount={500}
                    />
                  }
                  title={`${getI18n('legalPage.index.versionRemarks')}*`}
                  id='SalesChannelLegalPageEditorLegalSetting'>
                  <TextArea
                    error={versionRemarksErr}
                    maxLength={500}
                    onChange={handleOnRemarksChange}
                    value={versionRemarks}
                    autoSize={{ minRows: 1, maxRows: 5 }}
                    disabled={!canEdit}
                  />
                </ItemWrapper>
              ),
            },
            { child: <React.Fragment /> },
          ]}
        />
      </SectionContent>
      <SectionContent hasBottomBorder>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={
                    <Checkbox
                      checked={useDefaultLegalSetting}
                      onChange={handleOnDefaultChange}
                      disabled={!canEdit}>
                      {getI18n('legalPage.index.useDefaultSetting')}
                    </Checkbox>
                  }
                />
              ),
            },
          ]}
        />
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={getI18n('legalPage.index.entityName')}
                  {...(useDefaultLegalSetting
                    ? {}
                    : {
                        rightPart: (
                          <CountWords
                            count={(entityName || '').length}
                            allCount={100}
                          />
                        ),
                      })}>
                  {useDefaultLegalSetting ? (
                    <DefaultEntity
                      name={getI18n('legalPage.index.defaultentityname')}
                    />
                  ) : (
                    <Input
                      error={entityNameErr}
                      size='large'
                      value={entityName}
                      maxLength={100}
                      onChange={handleOnEntityNameChange}
                      disabled={!canEdit}
                    />
                  )}
                </ItemWrapper>
              ),
            },
            {
              child: (
                <ItemWrapper
                  title={getI18n('legalPage.index.entityRegistrationNumber')}
                  {...(useDefaultLegalSetting
                    ? {}
                    : {
                        rightPart: (
                          <CountWords
                            count={(entityRegistrationNumber || '').length}
                            allCount={100}
                          />
                        ),
                      })}>
                  {useDefaultLegalSetting ? (
                    <DefaultEntity
                      name={getI18n('legalPage.index.defaultentitynumber')}
                    />
                  ) : (
                    <Input
                      error={entityRegistrationNumberErr}
                      size='large'
                      maxLength={100}
                      value={entityRegistrationNumber}
                      onChange={handleOnEntityNumberChange}
                      disabled={!canEdit}
                    />
                  )}
                </ItemWrapper>
              ),
            },
          ]}
        />
      </SectionContent>
      <SectionContent>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  id={arrId}
                  rightSubTitle={getI18n(
                    'legalPage.index.consentAttributesSubtTitle',
                  )}
                  title={getI18n('legalPage.index.consentAttributes')}>
                  <Att
                    data={consentAttributes}
                    onChange={handleOnConsentAttributesChange}
                    disabled={!canEdit}
                  />
                </ItemWrapper>
              ),
            },
            { child: <React.Fragment /> },
          ]}
        />
      </SectionContent>
    </React.Fragment>
  );
};

export default SectionHOC(LegalSetting, {
  id: EnumCollapseId.LegalSetting,
  title: getI18nFromGeneral('general.hOCTitle.legalSetting'),
  getCollapse,
  onCollapseChange,
  collapseProps: { contentClassName: css.collapseContent },
});
const Att = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //data:{value:string,title:string}
  const { data = [], onChange, disabled } = props;
  const [inputTag, setInputTag] = React.useState('');
  const [visible, setVisible] = React.useState(false);
  const _data = React.useCallback(() => {
    return _.cloneDeep(data || []);
  }, [data]);

  const _onBlur = () => {
    setVisible(false);
  };
  React.useEffect(() => {
    window.addEventListener('click', _onBlur);
    return () => {
      return window.removeEventListener('click', _onBlur);
    };
  }, []);
  const defaultSelection = [
    {
      value: 'Marketing Email',
      title: getI18n('legalPage.index.marketingEmail'),
    },
    {
      value: 'Marketing Phone Call',
      title: getI18n('legalPage.index.marketingPhoneCall'),
    },

    {
      value: 'Marketing Mail',
      title: getI18n('legalPage.index.marketingMail'),
    },
    {
      value: 'Privacy Policy',
      title: getI18n('legalPage.index.privacyPolicy'),
    },
    {
      value: 'Marketing SMS',
      title: getI18n('legalPage.index.marketingSMS'),
    },
    {
      value: 'Membership',
      title: getI18n('legalPage.index.membership'),
    },
  ];
  const selectedValue = data.map((i) => i.value);
  const _defaultSelection = defaultSelection.filter(
    (i) => !selectedValue.includes(i.value),
  );

  const _onChange = (data) => {
    if (onChange) {
      onChange(data);
    }
  };

  const handleOnTagClose = (e, index) => {
    const _d = _data();
    _d.splice(index, 1);

    _onChange(_d);
  };

  const handleOnTagAdd = (tag) => {
    if (tag) {
      const _d = _data();
      const flag = _d.find((i) => i.value === tag);
      if (!flag) {
        _d.push({ title: tag, value: tag });
        _onChange(_d);
        //_onBlur();
      }
    }
  };

  const handleOnTagInputPress = (e) => {
    e.target.blur();
    if (inputTag) {
      handleOnTagAdd(inputTag);
      setInputTag('');
      _onBlur();
    }
  };

  const overlay = React.useMemo(
    () => (
      <div
        className={css.attContainer}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}>
        {_defaultSelection.length > 0 ? (
          _defaultSelection.map((i) => {
            return (
              <div
                className={css.tag}
                key={i.value}
                onClick={() => {
                  handleOnTagAdd(i.title);
                }}>
                <AddableTag text={i.title} textWidth={120} />
              </div>
            );
          })
        ) : (
          <div className={css.empty}>
            <Empty
              description={getI18n('legalPage.index.nomoredefaultAttributes')}
            />
          </div>
        )}
      </div>
    ),
    [_defaultSelection],
  );

  return (
    <React.Fragment>
      <DropDown
        placement={EnumPosition.bottomLeft}
        onFocus={setVisible.bind(this, true)}
        visible={visible}
        overlay={overlay}
        trigger={['click']}
        onClick={(e) => e.stopPropagation()}
        getPopupContainer={() => {
          return document.getElementById(arrId);
        }}
        disabled={disabled}
        overlayClassName={css.overlay}>
        <Input
          placeholder={getI18n('legalPage.index.addconsentattributes')}
          size='large'
          value={inputTag}
          onChange={setInputTag}
          onPressEnter={handleOnTagInputPress}
          disabled={disabled}
        />
      </DropDown>

      <div className={css.selectedTagContainer}>
        {data.map((i, index) => {
          return (
            <div className={css.tag} key={i.value}>
              <ClosableTag
                index={index}
                text={i.title}
                textWidth={120}
                onClose={handleOnTagClose}
                closable={!disabled}
              />
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

// const Tags = (props) => {
//   const { value, title, onClick } = props;
// };
const DefaultEntity = ({ name }) => {
  return <div className={css.defaultEntity}>{name}</div>;
};
